module.exports = __webpack_public_path__ + "img/pointer01.35968b1b.png";